export default __webpack_public_path__ + "static/media/security-details-upload-order-list.da1da25e.svg";